import { Navigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useUserLocation from "../hooks/useUserLocation";
import {
  getEventsListPath,
  getCityLabelFromSlug,
  resolveDefaultCityLabel,
} from "../utils/clubPath";

/** /events or /events?city=Goa → /events/Goa */
const EventsRedirect = () => {
  const [searchParams] = useSearchParams();
  const selectedCity = useSelector((state) => state.citySelector.selectedCity);
  const { locationData } = useUserLocation();

  const queryCity = searchParams.get("city");
  const label = queryCity
    ? getCityLabelFromSlug(queryCity)
    : resolveDefaultCityLabel(selectedCity, locationData?.city);

  return <Navigate to={getEventsListPath(label)} replace />;
};

export default EventsRedirect;
